<script>
import {blurRule, getLocalItem, setLocalItem} from '@/untils/common';
import { loginRequest, sendSmsCode } from "@/lib/request"
import { ClientId } from "@/lib/cli";
// 短信超限提醒弹窗
import Tips from '@/components/tips/index'
export default {
  name:'login',
  data(){
    return {
      url_openid: '',
      year: null,
      activeTab: 0,
      phone: '',
      code: '',
      disable: false,
      count: 0,
      timer: null,
      flagTips: false,
      popupText: ''
    }
  },
  components: {
    Tips
  },
  methods: {
    async initUrl() {
      // this.isLogining = true
      try {
        await this.login1()
        // this.isLogining = false
      } catch (err) {
        // console.log(err);
        // this.isLogining = false
      }
    },
    getPhoneCode() {
      let self = this;
      if (self.phone === '') {
        self.$toast('请输入手机号码');
        return false;
      } else if (!blurRule(self.phone, {name: 'phone'})) {
        return false;
      } else {
        sendSmsCode({phonenumber: this.phone}).then(res => {
          if (res.data.code === 200) {
            self.disable = true;
            const TIME_COUNT = 60;
            if (!self.timer) {
              self.count = TIME_COUNT;
              self.timer = setInterval(() => {
                if (self.count > 0 && self.count <= TIME_COUNT) {
                  self.count--;
                } else {
                  clearInterval(self.timer);
                  self.timer = null;
                  self.disable = false;
                }
              }, 1000)
            }
            this.$toast.success(res.data.msg)
          } else {
            // this.timeCount = 0;
            // this.$toast.fail(res.data.msg);
          }
        }).catch((res) => {
          if (res.data.msg.indexOf('超过频率限制') !== -1) {
            //验证码超过限制提示弹窗找客服
            this.flagTips = true;
            this.popupText = `短信验证码已超次数限制，请1小时后再试或者联系客服电话<a href="tel:0891-6187785" style="color: #006EFF">0891-6187785</a>或者点击<a href="https://hqxcxzfc.qiyukf.com/client?k=25bbb36de4d552ce8dbda2423fafd194&wp=1&robotShuntSwitch=0&gid=583010284&language=zh-cn&templateId=8132161"  style="color: #006EFF">在线客服</a>咨询`
            return false;
          }
          // this.timeCount = 0;
        });
      }
    },
    login() {
      if (this.phone === '') {
        this.$toast('请输入您的手机号码');
        return false;
      } else if (!blurRule(this.phone, {name: 'phone'})) {
        return false;
      } else if (this.code === '') {
        this.$toast('请输入短信验证码');
        return false;
      } else {
        if (!this.url_openid) {
          this.$toast("请从微信公众号，重新登录");
          return false;
        }
        if (this.url_openid.length !== 28) {
          this.$toast("请从微信公众号，重新登录");
          return false;
        }
        // 根据手机号提交登陆接口
        const data = {
          tenantId: "000000",
          username: this.phone,
          password: '',
          rememberMe: '',
          phonenumber: this.phone,
          smsCode: this.code,
          socialCode: '',
          socialState: '',
          source: '',
          code: '',
          uuid: '',
          openid: this.url_openid,
          clientId: ClientId,
          grantType: 'wxhtml',
        }
        loginRequest(data).then((res) => {
          if (res.data.code === 200) {
            setLocalItem('access_token', res.data.data.access_token);
            setLocalItem('user_id', res.data.data.user_id);
            // setLocalItem('postName', res.data.data.postName);
            setLocalItem('roles', res.data.data.roles);
            let nickName = res.data.data.nickName;
            setLocalItem('phone', res.data.data.phone);
            setLocalItem('deptName', res.data.data.deptName);
            if (nickName === 'undefined' || nickName === undefined || nickName === null || nickName === '') {
              nickName = "-"
            }
            setLocalItem('nickName', nickName);
            let arr = res.data.data.roles;
            let att = arr.split(',');
            //一人多角色
            if (att.length > 1) {
              if (att[0].indexOf('代销者') !== -1) {
                this.$router.push({path: '/userHome', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('销售员') !== -1) {
                this.$router.push({path: '/userHome', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('专管员') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('渠道') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('思乐') !== -1) {
                this.$router.push({path: '/serviceTask', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('分中心') !== -1) {
                this.$router.push({path: '/channelIndex', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('分拣员') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('技术部') !== -1) {
                this.$router.push({path: '/serviceTask', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('测试组') !== -1) {
                this.$router.push({path: '/personal', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('绩效管理员') !== -1) {
                this.$router.push({path: '/centerHome', query: {openid: this.url_openid}});
              } else {
                this.$toast(`【${att[0]}】平台暂未配置此角色`);
                return false;
              }
            } else {
              //一人一个角色
              if (arr.indexOf('代销者') !== -1) {
                this.$router.push({path: '/userHome', query: {openid: this.url_openid}});
              } else if (arr.indexOf('销售员') !== -1) {
                this.$router.push({path: '/userHome', query: {openid: this.url_openid}});
              } else if (arr.indexOf('专管员') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (arr.indexOf('渠道') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (arr.indexOf('思乐') !== -1) {
                this.$router.push({path: '/serviceTask', query: {openid: this.url_openid}});
              } else if (arr.indexOf('分中心') !== -1) {
                this.$router.push({path: '/channelIndex', query: {openid: this.url_openid}});
              } else if (arr.indexOf('分拣员') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (arr.indexOf('技术部') !== -1) {
                this.$router.push({path: '/serviceTask', query: {openid: this.url_openid}});
              } else if (arr.indexOf('测试组') !== -1) {
                this.$router.push({path: '/personal', query: {openid: this.url_openid}});
              } else if (arr.indexOf('绩效管理员') !== -1) {
                this.$router.push({path: '/centerHome', query: {openid: this.url_openid}});
              } else {
                this.$toast(`【${arr}】平台暂未配置此角色`);
                return false;
              }
            }
          } else {
            this.$toast.fail(res.data.msg);
          }
        });
      }
    },
    async login1() {
      let openId = getLocalItem('open_id');
      if (openId === 'undefined' || openId === undefined || openId === null || openId === '') {
        this.$toast("请从微信公众号，重新登录");
        return false;
      } else {
        if (openId.length !== 28) {
          this.$toast("请从微信公众号，重新登录");
          return false;
        }
        const data = {
          tenantId: "000000",
          username: "automate",
          password: "automate",
          rememberMe: '',
          phonenumber: "12345678",
          smsCode: "1234",
          socialCode: '',
          socialState: '',
          source: '',
          code: '',
          uuid: '',
          openid: openId,
          clientId: ClientId,
          grantType: 'wxhtml',
        }
        await loginRequest(data).then((res) => {
          if (res.data.code === 200) {
            // console.log(res.data.data.access_token)
            setLocalItem('access_token', res.data.data.access_token);
            setLocalItem('user_id', res.data.data.user_id);
            // setLocalItem('postName', res.data.data.postName);
            setLocalItem('roles', res.data.data.roles);
            setLocalItem('deptName', res.data.data.deptName);
            setLocalItem('phone', res.data.data.phone);
            let nickName = res.data.data.nickName;
            if (nickName === 'undefined' || nickName === undefined || nickName === null || nickName === '') {
              nickName = "-"
            }
            setLocalItem('nickName', nickName);
            let arr = res.data.data.roles;
            let att = arr.split(',');
            //一人多角色
            if (att.length > 1) {
              if (att[0].indexOf('代销者') !== -1) {
                this.$router.push({path: '/userHome', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('销售员') !== -1) {
                this.$router.push({path: '/userHome', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('专管员') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('渠道') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('思乐') !== -1) {
                this.$router.push({path: '/serviceTask', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('分中心') !== -1) {
                this.$router.push({path: '/channelIndex', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('分拣员') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('技术部') !== -1) {
                this.$router.push({path: '/serviceTask', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('测试组') !== -1) {
                this.$router.push({path: '/personal', query: {openid: this.url_openid}});
              } else if (att[0].indexOf('绩效管理员') !== -1) {
                this.$router.push({path: '/centerHome', query: {openid: this.url_openid}});
              } else {
                this.$toast(`【${att[0]}】平台暂未配置此角色`);
                return false;
              }
            } else {
              //一人一个角色
              if (arr.indexOf('代销者') !== -1) {
                this.$router.push({path: '/userHome', query: {openid: this.url_openid}});
              } else if (arr.indexOf('销售员') !== -1) {
                this.$router.push({path: '/userHome', query: {openid: this.url_openid}});
              } else if (arr.indexOf('专管员') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (arr.indexOf('渠道') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (arr.indexOf('思乐') !== -1) {
                this.$router.push({path: '/serviceTask', query: {openid: this.url_openid}});
              } else if (arr.indexOf('分中心') !== -1) {
                this.$router.push({path: '/channelIndex', query: {openid: this.url_openid}});
              } else if (arr.indexOf('分拣员') !== -1) {
                this.$router.push({path: '/techHome', query: {openid: this.url_openid}});
              } else if (arr.indexOf('技术部') !== -1) {
                this.$router.push({path: '/serviceTask', query: {openid: this.url_openid}});
              } else if (arr.indexOf('测试组') !== -1) {
                this.$router.push({path: '/personal', query: {openid: this.url_openid}});
              } else if (arr.indexOf('绩效管理员') !== -1) {
                this.$router.push({path: '/centerHome', query: {openid: this.url_openid}});
              } else {
                this.$toast(`【${arr}】平台暂未配置此角色`);
                return false;
              }
            }
          } else {
            this.$toast.fail(res.data.msg)
          }
        })
      }
    },
    getLocation(type) {
      if (this.url_openid) {
        if (type === 1) {
          this.$router.push({path: '/register', query: {openid: this.url_openid}})
        } else {
          this.$router.push({path: '/forgotPhone', query: {openid: this.url_openid}})
        }
      } else {
        this.$toast('暂无openid，请退出公众号，重新进来！');
      }
    },
  },
  created() {
    // 从公众号进来，先判断是否登陆过
    // 如果登陆过，直接无感登陆
    // 如果没有登录过，自己填写手机号验证码登录
    // 获取openid
    this.url_openid = this.$route.query.openid;
    if (this.$route.query.openid) {
      this.url_openid = this.$route.query.openid;
    } else {
      this.url_openid = getLocalItem('open_id');
    }
    this.initUrl();
    this.year = new Date().getFullYear();
  }
}
</script>

<template>
  <div class="login">
    <Tips v-model="flagTips" title="提示" :popupText="popupText"></Tips>
    <div class="login-header">
      <div class="header-title">西藏福彩网点管理系统</div>
    </div>
    <div class="content">
      <div class="login-card">
        <div class="welcome-text">
          <div class="welcome-title">欢迎登录</div>
          <div class="welcome-subtitle">请使用您的手机号进行登录</div>
        </div>
        <!--        <van-tabs v-model="activeTab" animated swipeable sticky>-->
        <!--          <van-tab title="专管员"></van-tab>-->
        <!--          <van-tab title="维修员"></van-tab>-->
        <!--          <van-tab title="代销者"></van-tab>-->
        <!--          <van-tab title="销售员"></van-tab>-->
        <!--        </van-tabs>-->
        <!--        <div class="line"></div>-->
        <!--        <div class="form-group" v-show="activeTab!==3">-->
        <!--          <label class="form-label">身份证号</label>-->
        <!--          <input type="tel" class="form-input" v-model="idCard" placeholder="请输入身份证号" />-->
        <!--        </div>-->

        <div class="form-group">
          <label class="form-label">手机号码</label>
          <input type="tel" class="form-input" v-model="phone" placeholder="请输入手机号码" maxlength="11"/>
        </div>

        <div class="form-group">
          <label class="form-label">验证码</label>
          <div class="verification-group">
            <input type="number" class="form-input verification-input" v-model="code" placeholder="请输入验证码"
                   maxlength="6"/>
            <button class="verification-button" :class="disable?'disabled':''">
              <span v-show="disable">{{ count }}s后重新获取</span>
              <span v-show="!disable" @click="getPhoneCode">获取验证码</span>
            </button>
          </div>
        </div>

        <button class="login-button" @click="login()">登录</button>
        <div class="registration-link">
          <div style="color: #e62d2d" @click="getLocation(2)">忘记手机号？去更换</div>
          <div style="color: #e62d2d" @click="getLocation(1)">销售员注册</div>
        </div>
      </div>
    </div>
    <div class="login-footer">
      版权所有 © {{ year }} 西藏自治区福利彩票发行中心
    </div>
  </div>
</template>

<style scoped lang="scss">
.line {
  width: 100%;
  height: 20px;
  border-top: 1px solid var(--border-color);
}

.login {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.login-header {
  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
  color: white;
  padding: 23px;
  text-align: center;
  box-shadow: var(--shadow);
}

.header-title {
  font-size: 32px;
  font-weight: 600;
}

.content {
  flex: 1;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-card {
  background: white;
  border-radius: var(--radius-md);
  padding: 24px;
  width: 100%;
  box-shadow: var(--shadow);
}

.welcome-text {
  text-align: center;
  margin-bottom: 24px;
}

.welcome-title {
  font-size: 44px;
  font-weight: 600;
  color: var(--text-color);
  margin-bottom: 8px;
}

.welcome-subtitle {
  font-size: 28px;
  color: var(--text-secondary);
}

.form-group {
  margin-bottom: 16px;
  background: white;
}

.form-label {
  display: block;
  margin-bottom: 20px;
  font-size: 28px;
  color: var(--text-secondary);

}

.form-input {
  width: 100%;
  padding: 20px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 28px;
  background-color: #f9f9f9;
}

.verification-group {
  display: flex;
  gap: 12px;
}

.verification-input {
  flex: 1;
}

.verification-button {
  width: 220px;
  border: 1px solid var(--primary-color);
  background: transparent;
  color: var(--primary-color);
  border-radius: var(--radius-sm);
  font-size: 28px;
  cursor: pointer;
  transition: all 0.2s;
}

.verification-button:active {
  background-color: #fff8f8;
}

.verification-button.disabled {
  border-color: var(--text-light);
  color: var(--text-light);
  cursor: not-allowed;
}

.login-button {
  width: 100%;
  padding: 20px;
  background: var(--primary-color);
  border: none;
  border-radius: var(--radius-sm);
  color: white;
  font-size: 28px;
  font-weight: 500;
  margin-top: 24px;
  cursor: pointer;
  transition: all 0.2s;
}

.login-button:hover {
  background: var(--primary-dark);
}

.login-button:active {
  transform: translateY(1px);
}

.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 12px 24px;
  border-radius: 100px;
  font-size: 28px;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.3s;
}

.toast.show {
  opacity: 1;
}

.login-footer {
  text-align: center;
  padding: 16px;
  color: var(--text-light);
  font-size: 28px;
}

.registration-link {
  display: flex;
  justify-content: space-between;
  height: 70px;
  text-align: center;
  padding: 35px 0 10px;
  box-sizing: border-box;
  color: var(--text-secondary);
}

.registration-link a {
  display: flex;
  color: var(--primary-color);
  text-decoration: none;
}
</style>